export const queryKeys = {
    // Courses
    courseBySlug: slug => ['course', 'slug', slug],
    coursesList: params => ['courses', 'list', params],
    courseContent: slug => ['course', 'content', slug],
    courseInstructors: courseId => ['course', 'instructors', courseId],
    enrollmentStatus: courseId => ['course', 'enrollment', courseId],
    userCourses: params => ['courses', 'user', params],

    // Completions
    lessonCompletions: (userId, courseId) => ['completions', 'lesson', userId, courseId],
    projectCompletions: (userId, courseId) => ['completions', 'project', userId, courseId],
    quizCompletions: (userId, courseId) => ['completions', 'quiz', userId, courseId],

    // Projects
    project: projectId => ['project', projectId],
    userSubmissions: (userId, params) => ['project', 'submissions', userId, params],

    // Quiz
    quizQuestions: quizId => ['quiz', 'questions', quizId],
    quizAttempts: (quizId, userId) => ['quiz', 'attempts', quizId, userId],

    // Pathways
    userPathways: () => ['pathways', 'user'],
    pathwayProgress: (userId, pathwayId) => ['pathway', 'progress', userId, pathwayId],
    pathwayCourses: pathwayId => ['pathway', 'courses', pathwayId],
    pathwayGradebook: (userId, pathwayId) => ['pathway', 'gradebook', userId, pathwayId],

    // Cohorts
    userCohortEnrollments: userId => ['cohort', 'enrollments', userId],
    cohortLeaderboard: params => ['cohort', 'leaderboard', params],
    cohortEnrollments: (cohortId, params) => ['cohort', 'enrolments', cohortId, params],

    // Live classes
    upcomingSessions: params => ['liveclasses', 'upcoming', params],
    ongoingSessions: () => ['liveclasses', 'ongoing'],
    attendanceLogs: (userId, params) => ['liveclasses', 'attendance', userId, params],

    // Gamification
    userXp: userId => ['gamification', 'xp', userId],
    userStreak: userId => ['gamification', 'streak', userId],
    userBadgeProgress: userId => ['gamification', 'badges', userId],
    userStats: () => ['gamification', 'stats'],

    // Notifications
    notifications: params => ['notifications', params],
};

export default queryKeys;
